import React from "react";
import axios from "axios";
import validator from 'validator';
import { notifications } from '@mantine/notifications';
import { Box, Group, Drawer, Textarea, Button, ActionIcon, Text } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';

import { useLoginContext } from "../../context/loginContext";
import { BE_API_ONE, utils } from "../../utils/globalVariables";

import InputComponent from "../../components/general/InputComponent";
import ModalResponse from "../../components/general/ModalResponse";

const SupplierAdd = ({
    stateShow,
    fnShow,
    fnSuccessAdd,
}) => {

    const mountedRef = React.useRef(true);

    // const theme = useMantineTheme();
    const { loginContext, handleSetLoginContext } = useLoginContext();

    const notificationId = React.useRef({
        errorSubmitData: 'supplierAdd-1',
        successSubmitData: 'supplierAdd-2',
    })

    const constSupplierName = {
        id: 'addSupplierName',
        label: 'Supplier',
        withAsterisk: true,
        placeholder: 'Supplier',
        value: '',
        description: '',
        error: ''
    }

    const constSupplierAddress = {
        id: 'addSupplierAddress',
        label: 'Alamat',
        withAsterisk: false,
        placeholder: 'Alamat',
        value: '',
        description: '',
        error: ''
    }

    const constSupplierContact = {
        id: 'addSupplierContact',
        label: 'Kontak',
        withAsterisk: false,
        placeholder: 'Kontak',
        value: '',
        description: '',
        error: ''
    }

    const constSupplierInfo = {
        id: 'addSupplierInfo',
        label: 'Keterangan',
        withAsterisk: false,
        placeholder: 'Keterangan',
        value: '',
        description: '',
        error: ''
    }

    const [data, setData] = React.useState({
        supplierName: constSupplierName,
        supplierAddress: constSupplierAddress,
        supplierContact: constSupplierContact,
        supplierInfo: constSupplierInfo,

        submitLoading: false,

        modalResponse: {
            show: false,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: false,
            content: ''
        }
    });

    React.useEffect(() => {
        return () => {
            mountedRef.current = false;
        }
    }, [])

    const resetData = () => {
        setData(d => ({
            ...d,
            supplierName: constSupplierName,
            supplierAddress: constSupplierAddress,
            supplierContact: constSupplierContact,
            supplierInfo: constSupplierInfo,
        }))
    }

    const addData = () => {
        setData(d => ({
            ...d,
            supplierName: { ...d.supplierName, error: '' },
        }));

        if (validator.isEmpty(data.supplierName.value, { ignore_whitespace: true })) {
            setData(d => ({ ...d, supplierName: { ...d.supplierName, error: 'Nama supplier wajib diisi!', } }));
        } else {

            setData(d => ({ ...d, submitLoading: true }));

            const formDT = new FormData();
            const formDTHeader = { 'Content-Type': 'application/json' }

            formDT.append('json_token', loginContext.syswebapp);
            formDT.append('supplier_name', data.supplierName.value);
            formDT.append('supplier_address', data.supplierAddress.value);
            formDT.append('supplier_contact', data.supplierContact.value);
            formDT.append('supplier_info', data.supplierInfo.value);

            axios({
                method: 'post',
                url: BE_API_ONE + '/add_supplier',
                data: formDT,
                headers: formDTHeader,
            }).then((response) => {
                if (!mountedRef.current) return null;

                setData(d => ({ ...d, submitLoading: false }));

                if (response.data.flag_status === 'isset') {

                    resetData();
                    fnSuccessAdd();

                    notifications.show({
                        id: notificationId.current.successSubmitData,
                        title: utils.notification.success.caption,
                        message: 'Berhasil Tambah Data.',
                        color: utils.notification.success.color,
                        icon: utils.notification.success.icon,
                        withBorder: true,
                        autoClose: true,
                    })
                }

                if (response.data.flag_status === 'error') {
                    notifications.show({
                        id: notificationId.current.errorSubmitData,
                        title: utils.notification.warning.caption,
                        message: response.data.pesan,
                        color: utils.notification.warning.color,
                        icon: utils.notification.warning.icon,
                        withBorder: true,
                        autoClose: true,
                    })
                }

                if (response.data.flag_status === 'duplicate-name') {
                    setData(d => ({
                        ...d,
                        modalResponse: {
                            ...d.modalResponse,
                            type: utils.modalResponse.warning,
                            hideOnClickOutSide: false,
                            content: `Nama supplier ${response.data.suspect} sudah pernah digunakan.`,
                            show: true
                        }
                    }))
                }

                if (response.data.flag_status === 'invalid-json-token') {
                    handleSetLoginContext(null);
                }

                if (response.data.flag_status === 'user-inactive') {
                    handleSetLoginContext(null);
                }
            }).catch(error => {
                if (!mountedRef.current) return null;

                setData(d => ({ ...d, submitLoading: false }));

                notifications.show({
                    id: notificationId.current.errorSubmitData,
                    title: utils.notification.warning.caption,
                    message: error.message,
                    color: utils.notification.warning.color,
                    icon: utils.notification.warning.icon,
                    withBorder: true,
                    autoClose: false,
                })
            })
        }
    }

    return (
        <React.Fragment>
            <Drawer
                opened={stateShow}
                onClose={fnShow}
                withCloseButton={false}
                position="left"
                closeOnClickOutside={true}

                title={
                    <Group noWrap spacing='xs'>
                        <ActionIcon
                            size='lg'
                            variant="light"
                            radius='xl'
                            color="blue"
                            onClick={fnShow}
                        >
                            <IconArrowLeft size='1.25rem' stroke={1.5} />
                        </ActionIcon>

                        <Text>Tambah Supplier</Text>
                    </Group>
                }
                size='md'

                styles={() => ({
                    title: {
                        fontWeight: 'bold',
                        textTransform: 'uppercase'
                    }
                })}
            >
                <Box py='md'>

                    <Box mb='2rem'>
                        <InputComponent
                            stateId={data.supplierName.id}
                            stateWithAsterisk={data.supplierName.withAsterisk}
                            stateLabel={data.supplierName.label}
                            stateDescription={data.supplierName.description}
                            statePlaceHolder={data.supplierName.placeholder}
                            stateValue={data.supplierName.value}
                            stateError={data.supplierName.error}

                            fnOnChange={(e) => setData(d => ({
                                ...d,
                                supplierName: {
                                    ...d.supplierName,
                                    value: e.target.value
                                }
                            }))}
                        />
                    </Box>

                    <Box mb='2rem'>
                        <InputComponent
                            stateId={data.supplierAddress.id}
                            stateWithAsterisk={data.supplierAddress.withAsterisk}
                            stateLabel={data.supplierAddress.label}
                            stateDescription={data.supplierAddress.description}
                            statePlaceHolder={data.supplierAddress.placeholder}
                            stateValue={data.supplierAddress.value}
                            stateError={data.supplierAddress.error}

                            fnOnChange={(e) => setData(d => ({
                                ...d,
                                supplierAddress: {
                                    ...d.supplierAddress,
                                    value: e.target.value
                                }
                            }))}
                        />
                    </Box>

                    <Box mb='2rem'>
                        <InputComponent
                            stateId={data.supplierContact.id}
                            stateWithAsterisk={data.supplierContact.withAsterisk}
                            stateLabel={data.supplierContact.label}
                            stateDescription={data.supplierContact.description}
                            statePlaceHolder={data.supplierContact.placeholder}
                            stateValue={data.supplierContact.value}
                            stateError={data.supplierContact.error}

                            fnOnChange={(e) => setData(d => ({
                                ...d,
                                supplierContact: {
                                    ...d.supplierContact,
                                    value: e.target.value
                                }
                            }))}
                        />
                    </Box>

                    <Box mb='2rem'>
                        <Textarea
                            value={data.supplierInfo.value}
                            onChange={(e) => setData(d => ({
                                ...d,
                                supplierInfo: {
                                    ...d.supplierInfo,
                                    value: e.target.value
                                }
                            }))}

                            label={data.supplierInfo.label}
                            placeholder={data.supplierInfo.placeholder}
                            error={data.supplierInfo.error}
                            description={data.supplierInfo.description}
                            withAsterisk={data.supplierInfo.withAsterisk}
                        />
                    </Box>

                    <Group position="apart" noWrap spacing='xs' my='xl'>
                        <Button
                            fullWidth
                            variant="default"
                            color='gray'
                            onClick={resetData}
                        >
                            Reset
                        </Button>

                        <Button
                            fullWidth
                            // variant="default"
                            // color='teal'
                            loading={data.submitLoading}
                            onClick={addData}
                        >
                            Submit
                        </Button>
                    </Group>
                </Box>
            </Drawer>

            <ModalResponse
                stateShow={data.modalResponse.show}
                fnHide={() => setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        show: false
                    }
                }))}

                stateHideOnClickOutSide={data.modalResponse.hideOnClickOutSide}
                stateType={data.modalResponse.type}
                stateContent={data.modalResponse.content}
            />
        </React.Fragment>
    )
}

export default SupplierAdd;